export default __webpack_public_path__ + "static/media/success.2fa73b36.svg";